(function() {
    'use strict';
    angular
        .module('mlcccApp')
        .factory('ClassRoom', ClassRoom);

    ClassRoom.$inject = ['$resource'];

    function ClassRoom ($resource) {
        var resourceUrl =  'api/class-rooms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
